<template>
    <div>
        <div><p class='tips1'>404</p></div>
        <div><p class='tips2'>你访问的页面丢失了！</p></div>
    </div>
</template>

<script>
export default {

};
</script>

<style scoped>
/* .main {
    background: rgb(54, 78, 106);
    width: 100%;
    height: 100%;
} */
.tips1 {
    color: rgb(54, 78, 106);
    font-size: 200px;
}
.tips2 {
    /* color: rgb(191, 203, 217); */
    color: rgb(54, 78, 106);
    font-size: 25px;
}
</style>